import { render, staticRenderFns } from "./CommodityType.vue?vue&type=template&id=cd3109f2&scoped=true&"
import script from "./CommodityType.vue?vue&type=script&lang=js&"
export * from "./CommodityType.vue?vue&type=script&lang=js&"
import style0 from "./CommodityType.vue?vue&type=style&index=0&id=cd3109f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3109f2",
  null
  
)

export default component.exports